<template>
  <div class="alignment">
    <!-- <v-btn class="right" color="blue" > Modifica </v-btn>
    <v-btn class="right" color="red"  > Cancella </v-btn>-->

    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left">
          <h3 class="styleHeader">
            {{ $t("pages.UserCustomer.Index.MappaturaUtenteCommittente") }}
          </h3>
        </v-flex>
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'UsersCustomersCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.UserCustomer.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.UserCustomer.Index.Utente'),
            value: 'Id'
          },
          {
            text: this.currentLanguage.t(
              'pages.UserCustomer.Index.Committente'
            ),
            value: 'CustomerCodiceSocieta'
          },
          { text: '' },
          { text: '' }
        ]"
        :items="usersCustomers"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.UserName }} {{ props.item.UserSurname }}</td>
          <td>
            {{ props.item.CustomerName }} (
            {{ props.item.CustomerCodiceSocieta }} )
          </td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn flat icon class="right" @click="confirm(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-alert
        class="centerButton"
        :value="conferma"
        transition="scale-transition"
      >
        {{ $t("pages.UserCustomer.Index.ConfermaElimina") }}
        <v-btn @click="deleteItem()">
          {{ $t("pages.UserCustomer.Index.Conferma") }}
        </v-btn>
        <v-btn @click="conferma = !conferma">
          {{ $t("pages.UserCustomer.Index.Annulla") }}
        </v-btn>
      </v-alert>
    </template>
  </div>
</template>

<script>
import usersCustomersApi from "../../apiSmartLogistics/userscustomersApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      conferma: false,
      sUserCustomer: {},
      headers: [],
      usersCustomers: [],
      refreshMenu: ""
    };
  },

  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  methods: {
    creating() {
      usersCustomersApi.GetViewUsersCustomers().then(response => {
        this.usersCustomers = response.data;
      });
    },

    confirm(selectedUserCustomer) {
      this.sUserCustomer = selectedUserCustomer;
      this.conferma = true;
    },

    deleteItem() {
      usersCustomersApi
        .DeleteViewUsersCustomers(this.sUserCustomer.Id)
        .then(() => {
          this.conferma = false;
          this.$emit("refreshMenu", this.refreshMenu);
          this.creating();
        });
    },

    editItem(item) {
      router.push({ name: "UsersCustomersCreate", params: { Id: item.Id } });
    }
  },

  created() {
    this.creating();
  }
};
</script>
